export default __webpack_public_path__ + "static/media/offroad100000.b2528de6.jpg";